import type { FC } from "react";

const XpIcon: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="text-primary"
  >
    <g clipPath="url(#clip0_2860_3551)">
      <mask
        id="mask0_2860_3551"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="1"
        width="17"
        height="15"
      >
        <path d="M16.3333 1.33325H0V15.4133H16.3333V1.33325Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2860_3551)">
        <path
          d="M13.9401 9.74008L14.1601 9.36008C14.3862 8.97261 14.5053 8.53201 14.5053 8.08341C14.5053 7.6348 14.3862 7.19423 14.1601 6.80675L11.8935 2.92675C11.6709 2.54394 11.3519 2.22615 10.9682 2.00507C10.5845 1.78399 10.1496 1.66734 9.70682 1.66675H5.1335C4.68982 1.66751 4.25404 1.78418 3.86934 2.00518C3.48462 2.22619 3.16432 2.54387 2.94016 2.92675L0.666828 6.80675C0.445716 7.19107 0.329346 7.62669 0.329346 8.07008C0.329346 8.51348 0.445716 8.94908 0.666828 9.33341L2.92683 13.2134C3.14875 13.6032 3.46969 13.9275 3.85717 14.1534C4.24466 14.3793 4.68495 14.4989 5.1335 14.5001H8.17348"
          stroke="currentColor"
          strokeWidth="0.666667"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M16.2735 13.8202C16.5068 14.0668 15.9935 14.4868 15.6068 14.2002C15.6068 14.2002 13.5268 12.6002 13.2002 12.6002C12.8735 12.6002 10.8002 14.2002 10.8002 14.2002C10.4002 14.5135 9.88685 14.0668 10.1335 13.8202C10.1335 13.8202 12.9002 10.9202 13.2202 10.9202C13.5402 10.9202 16.2735 13.8202 16.2735 13.8202Z"
          fill="currentColor"
        />
        <path
          d="M13.1868 14.6667C13.699 14.8361 14.184 15.0786 14.6268 15.3867C14.9002 15.5734 15.2935 15.16 15.0735 14.9667C15.0735 14.9667 13.4468 13.1934 13.1868 13.1934C12.9268 13.1934 11.3335 14.9467 11.3335 14.9467C11.1402 15.14 11.5135 15.5534 11.7802 15.3667C12.2146 15.0697 12.688 14.8341 13.1868 14.6667Z"
          fill="currentColor"
        />
        <path
          d="M9 6.87345V7.91345H9.2C9.46 7.91345 9.86667 7.84678 9.86667 7.35345C9.86667 6.86012 9.22667 6.84678 9 6.87345Z"
          fill="currentColor"
        />
        <path
          d="M13.007 7.80662L10.4536 3.55329C10.4059 3.47196 10.3377 3.40456 10.2558 3.35777C10.174 3.31098 10.0812 3.28646 9.98696 3.28662H4.84695C4.75351 3.28627 4.66166 3.31078 4.58083 3.35764C4.49999 3.4045 4.43307 3.47203 4.38695 3.55329L1.83361 7.80662C1.78153 7.8895 1.75391 7.9854 1.75391 8.08329C1.75391 8.18116 1.78153 8.27709 1.83361 8.35996L4.38695 12.6133C4.43307 12.6946 4.49999 12.7621 4.58083 12.809C4.66166 12.8558 4.75351 12.8803 4.84695 12.88H8.94696L13.007 8.35996C13.0562 8.27609 13.0821 8.18056 13.0821 8.08329C13.0821 7.98602 13.0562 7.89052 13.007 7.80662ZM7.06029 10.16C6.97196 10.1608 6.88523 10.1368 6.80983 10.0908C6.73443 10.0449 6.67343 9.97876 6.63361 9.89996L6.32028 9.33329L6.06695 8.86662C6.00028 9.00663 5.92695 9.15329 5.83361 9.33329L5.54695 9.89329C5.50791 9.97516 5.44649 10.0442 5.3698 10.0926C5.29311 10.141 5.20429 10.1666 5.11361 10.1666H4.28695L5.33361 8.33329C5.37627 8.25809 5.39869 8.17309 5.39869 8.08663C5.39869 8.00016 5.37627 7.91517 5.33361 7.83996L4.32695 6.07329H5.16695C5.25591 6.07353 5.34315 6.09782 5.41943 6.14359C5.49571 6.18936 5.55821 6.2549 5.60028 6.33329L5.91361 6.92663C5.98028 7.06663 6.04695 7.18662 6.10028 7.30662C6.16028 7.18662 6.21361 7.06662 6.28695 6.93329L6.59361 6.33329C6.63569 6.2549 6.69816 6.18936 6.77449 6.14359C6.85076 6.09782 6.93796 6.07353 7.02696 6.07329H7.86696L6.82029 7.81996C6.77436 7.89525 6.75003 7.98175 6.75003 8.06996C6.75003 8.15816 6.77436 8.24469 6.82029 8.31996L7.90696 10.16H7.06029ZM10.5003 8.29996C10.1431 8.61496 9.67563 8.77556 9.20029 8.74662H9.00029V9.66663C9.00029 9.73056 8.98769 9.79382 8.96323 9.85289C8.93876 9.91189 8.90296 9.96556 8.85776 10.0108C8.81256 10.056 8.75889 10.0918 8.69983 10.1162C8.64083 10.1407 8.57749 10.1533 8.51363 10.1533C8.44969 10.1533 8.38643 10.1407 8.32736 10.1162C8.26836 10.0918 8.21469 10.056 8.16949 10.0108C8.12429 9.96556 8.08843 9.91189 8.06396 9.85289C8.03956 9.79382 8.02696 9.73056 8.02696 9.66663V6.13996H8.14696C8.50636 6.08329 8.86983 6.05654 9.23363 6.05996C9.66643 6.02771 10.0965 6.1506 10.447 6.40662C10.5798 6.52147 10.6862 6.66381 10.7588 6.82381C10.8313 6.9838 10.8682 7.15763 10.867 7.33329C10.8733 7.51071 10.8441 7.68761 10.7811 7.85361C10.7182 8.01963 10.6227 8.17136 10.5003 8.29996Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2860_3551">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default XpIcon;
